<template>
  <div >
  

    <!-- <g-pdf v-if="pdfAparecer"  :pdfFloat="false" :NovaGuia="true"> -->
  <div v-if="this.TipoCarta == 0">
    <div class="card-pdf-carta-proposta">
      <div class="conteudo-pdf-carta-proposta">
        <g-card class="card-principal" :temCabecalho="false" :expansivel="false" margem="0" paddingDefault="0">
          <div class="informacoes-pdf-carta-proposta">
            <div 
            class="container-principal-gerador-paginas" 
            v-for="(info, indexOrc) in this.orcamentosInformacoes" 
            :key="indexOrc"
            >
              <div class="html2pdf__page-break" v-if="indexOrc != 0"/>
              <div class="content-grupo">
                <div class="template-pagina" v-if="indexOrc === 0">
                  <div class="imagem-template-cabecalho cabecalho-primeiraPag">
                    <img src="@/assets/imgs/Cabecalho_Carta_Proposta.svg" class="img-rodape">

                    <div class="info-carta-cabecalho espaco-data-rodape conteudo-cabecalho-primeiraPag">
                      <div class="numero-carta-proposta titulo-conteudo-detalhes"> Carta-Proposta <div class="codigo-externo-primeiraPag"> #{{ this.codigoCarta != null ? this.codigoCarta : this.codigoExterno }} </div></div>
                      <div class="borda-grupo borda-carta-proposta"></div>
                      <div class="nome-unidade titulo-conteudo-detalhes">{{ cartaPropostaArray.nomeEmpresa }}</div>
                    </div>
                  </div>

                  <div class="imagem-template-rodape">
                    <div class="data-carta-proposta titulo-conteudo-detalhes data-rodape"> Jaú, {{ this.DiaHoje }} </div>
                    <img src="@/assets/imgs/Rodape_CartaProposta.svg" class="img-cabecalho">
                  </div> 
                </div>

                <div class="template-pagina" v-else>
                  <div class="imagem-template-cabecalho espaco-codigo-externo-cabecalho">
                    <div class="titulo-conteudo-detalhes label-codigo-externo"> #{{ this.codigoCarta != null ? this.codigoCarta : this.codigoExterno }} </div>
                    <img src="@/assets/imgs/Cabecalho_PDF_CartaProposta.svg" class="img-rodape">
                  </div>

                  <div class="imagem-template-rodape">
                    <div class="data-carta-proposta titulo-conteudo-detalhes data-rodape"> Jaú, {{ this.DiaHoje }} </div>
                    <img src="@/assets/imgs/Rodape_CartaProposta.svg" class="img-cabecalho">
                  </div> 
                </div>

                <div :class="`${indexOrc === 0 ? 'container-info-introducao-carta-proposta' : ''} grupo`">
                  <div class="titulo-referencia-nome-cliente borda-titulo-grupo" v-if="indexOrc === 0">
                    <div class="titulo-nome-cliente titulo-grupo"> À <br> {{ cartaPropostaArray.nomeCliente }} </div>
                    <div class="borda-grupo"></div>
                  </div>

                  <div class="informacoes-cliente" v-if="indexOrc === 0">
                    <div class="cliente descricao-cliente">
                      <div class="titulo-conteudo-detalhes"> A/Sr(a): </div>
                      <div class="nome-cliente label-conteudo">
                        {{
                          inputNomeCliente == "" ? "Nome do Cliente" : inputNomeCliente
                        }}
                      </div>
                    </div>
                    
                    <div class="mensagem label-conteudo"> Conforme solicitado, seguem abaixo preços e condições para fornecimento, a saber </div>
                  </div>

                  <div :class="`grupo-info-produto ${indexOrc != 0 ? 'espacamento-novo-orcamento' : ''}`">
                    <div class="conteudo-orcamento-info-produto">                  
                      <div class="orcamento-produto">
                        <div class="imagem-caixa-orcamento">
                          <img src="@/assets/imgs/icone_componente_orcamento.svg" class="img-orcamento">
                        </div>

                        <div class="conteudo-orcamento">
                          <div class="nome-produto titulo-conteudo-orcamento">
                            <div class="titulo-conteudo-detalhes produto-nome"> Nome do Produto: </div>
                            <div class="titulo-conteudo-detalhes pinta-label">{{info.nomeProduto}}</div>
                          </div>

                          <div class="codigo-orcamento titulo-conteudo-orcamento">
                            <div class="titulo-conteudo-detalhes"> Orçamento: </div>
                            <div class="titulo-conteudo-detalhes pinta-label">{{info.codigoOrcamento}}</div>
                          </div>

                          <div class="opcao titulo-conteudo-orcamento">
                            <div class="titulo-conteudo-detalhes"> Opção: </div>
                            <div class="titulo-conteudo-detalhes pinta-label">{{info.descricaoOpcao ? info.descricaoOpcao : 'Não cadastrado'}}</div>
                          </div>

                          <div class="frete titulo-conteudo-orcamento">
                            <div class="titulo-conteudo-detalhes"> Frete: </div>
                            <div class="titulo-conteudo-detalhes pinta-label">{{info.indicadorDeTipoFreteoEnum ? info.indicadorDeTipoFreteoEnum : '-'}}</div>
                          </div>
                        </div>
                      </div>

                      <div class="container-imagem-produto">
                        <div class="conteudo-sem-imagem" v-if = "info.temImagem == false">
                          <div class="imagem-produto">
                            <img src="@/assets/imgs/icone_componente_orcamento.svg" class="img-produto">
                          </div>              
                          <div class="label-sem-imagem label-conteudo"> Imagem indisponível! </div>
                        </div>  
                        <div class="conteudo-sem-imagem" v-if = "info.temImagem == true">
                          <div class="imagem-produto">
                            <img :src="info.linkImagemProduto" class="img-produto-oficial">
                          </div>              
                        </div>    
                      </div>
                    </div>

                    <div class="orcamento-tabela" v-if="info.orcamentoDatas.length > 0">
                      <div class="orcamento-tabela-conteudo">
                        <div class="cabecalho-tabela">
                          <div class="titulo-conteudo-detalhes titulo-tabela"> Quantidade </div>
                          <div class="titulo-conteudo-detalhes titulo-tabela"> Preço </div>
                        </div>
                        
                        <div 
                          class="informacao-tabela" 
                          v-for="(data2, index2) in info.orcamentoDatas"
                          :key="index2"
                        >
                          <div :class="`info-conteudo ${index2 % 2 === 0 ? 'pinta-linha' : 'nao-pinta-linha' }`">
                            <div class="label-conteudo label-tabela">{{ data2.quantidadeFormatada }}</div>
                            <div class="label-conteudo label-tabela"> R$ {{ data2.valorPrecoIdealFormatado }}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="container-principal-componentes">
                      <div :class="`borda-titulo-grupo ${indexOrc === 0 ? '' : 'titulo-componentes'}`">
                        <div class="titulo-grupo"> COMPONENTES </div>
                        <div class="borda-grupo"></div>
                      </div>

                      <div class="container-componentes" v-if="info.componentes.length > 0">
                        <div v-for="(data, index) in info.componentes" :key="index">
                          <div :class="`box-componente-t1 ${index % 2 == 0 ? 'box-componente-espacamento-t1' : ''}`" v-if="(index + 1) <= 2">
                            <div class="imagem-numero-nome-componente">
                              <div class="imagem-grupo-componente">
                                <img src="@/assets/imgs/icone_componente_orcamento.svg" class="img-componente">
                              </div>
                              
                              <div class="numero-nome-componente">
                                <div class="titulo-conteudo-detalhes numero-componente"> Componente {{ index + 1 }}</div>
                                <div class="nome-componente label-conteudo">{{ data.componenteTipoTexto }}</div>
                              </div>
                            </div> 

                            <div class="grupo-componentes">
                              <div class="componentes-medidas">
                                <div class="medidas titulo-conteudo-detalhes"> Medidas </div>
                                <div class="medidas label-conteudo">
                                  {{ 
                                    (data.numeroComprimento != 0) && (data.numeroLargura != 0)  ? 
                                    data.numeroComprimento + ' x ' + data.numeroLargura + ' x ' + data.numeroAltura + 
                                    ' x ' + data.numeroAlturaTampa : data.descricaoMedidasTexto
                                  }}
                                </div>
                              </div>

                              <div class="componentes-cor-frente">
                                <div class="corFrente titulo-conteudo-detalhes"> Cor Frente </div>
                                <div class="corFrente label-conteudo">{{ data.descricaoCoresFrenteTexto }}</div>
                              </div>

                              <div class="componentes-cor-verso">
                                <div class="corVerso titulo-conteudo-detalhes"> Cor Verso </div>
                                <div class="corVerso label-conteudo">{{ data.descricaoCoresVersoTexto }}</div>
                              </div>

                              <div class="componentes-acabFrente">
                                <div class="acabFrente titulo-conteudo-detalhes"> Acabamento Frente </div>
                                <div class="acabFrente label-conteudo">{{ data.descricaoAcabamentoFrenteTexto }}</div>
                              </div>

                              <div class="componentes-acabVerso">
                                <div class="acabVerso titulo-conteudo-detalhes"> Acabamento Verso </div>
                                <div class="acabVerso label-conteudo">{{ data.descricaoAcabamentoVersoTexto }}</div>
                              </div>

                              <div class="componentes-material">
                                <div class="material titulo-conteudo-detalhes"> Material </div>
                                <div class="material label-conteudo">{{ data.descricaoMaterialTexto }}</div>
                              </div>

                              <div class="componentes-onda">
                                <div class="onda titulo-conteudo-detalhes"> Onda </div>
                                <div class="onda label-conteudo">{{ data.descricaoOndaTexto }}</div>
                              </div>

                              <div class="componentes-capaExt">
                                <div class="capaExt titulo-conteudo-detalhes"> Capa Externa </div>
                                <div class="capaExt label-conteudo">{{ data.descricaoCapaExternaTexto }}</div>
                              </div>

                              <div class="componentes-capaInt">
                                <div class="capaInt titulo-conteudo-detalhes"> Capa Interna </div>
                                <div class="capaInt label-conteudo">{{ data.descricaoCapaInternaTexto }}</div>
                              </div>

                              <div class="componentes-papelOnda">
                                <div class="papelOnda titulo-conteudo-detalhes"> Papel de Onda </div>
                                <div class="papelOnda label-conteudo">{{ data.descricaoPapelOndaTexto }}</div>
                              </div>

                              <div class="componentes-descricao" v-if="data.descricaoSistema == 0">
                                <div class="desc-componente titulo-conteudo-detalhes"> Descrição do Sistema </div>
                                <div class="label-conteudo">{{ data.sistema }}</div>
                              </div>

                              <div class="componentes-produto" v-if="data.descricaoSistema == 2">
                                <div class="produto-comp titulo-conteudo-detalhes"> Produto </div>
                                <div class="label-conteudo">{{ data.produtoSistema }}</div>
                              </div>

                              <div class="componentes-prototipo" v-if="data.descricaoSistema == 3">
                                <div class="prototipo titulo-conteudo-detalhes"> Protótipo </div>
                                <div class="label-conteudo">{{ data.prototipoSistema }}</div>
                              </div>


                              <div class="componentes-prototipo" v-if="data.descricaoSistema == 4">
                                <div class="prototipo titulo-conteudo-detalhes"> Conforme Planta </div>
                              </div>

                              <div class="componentes-prototipo" v-if="data.descricaoSistema == 5">
                                <div class="prototipo titulo-conteudo-detalhes"> Conforme Arquivo Digital </div>
                              </div>

                              <div class="componentes-embalagem-coletiva" 
                                v-if="data.embalagens != 0 || data.quantidadeOutros != 0"
                              >
                                <div class="embalagem titulo-conteudo-detalhes"> Embalagem Coletiva </div>
                                <div class="labels-embalagem-coletiva">
                                  <div class="label-conteudo" v-for="(texto, index) in data.embalagens" :key="index"
                                  >{{ texto }}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="label-conteudo label-sem-componentes" v-else> Não possui componentes. </div>
                    </div>
                  </div>                
                </div>
              </div>

              <div class="html2pdf__page-break" v-if="info.componentes.length > 2"/> 
                
                <div class="html2pdf__page-break" v-if="indexOrc > 0 && !deveQuebrar"/> 

              <div class="content-grupo" v-if="info.componentes.length > 2">
                <div class="container-base">
                  <div class="contador-pag-componentes" v-for="e in Math.ceil(info.componentes.length / 4)" :key="e">
                    <div class="template-pagina-comp">
                      <div class="imagem-template-cabecalho espaco-codigo-externo-cabecalho">
                        <div class="titulo-conteudo-detalhes label-codigo-externo"> #{{ this.codigoCarta != null ? this.codigoCarta : this.codigoExterno }} </div>
                        <img src="@/assets/imgs/Cabecalho_PDF_CartaProposta.svg" class="img-cabecalho">
                      </div>

                      <div class="imagem-template-rodape espaco-data-rodape">
                        <div class="data-carta-proposta titulo-conteudo-detalhes data-rodape"> Jaú, {{ this.DiaHoje }} </div>
                        <img src="@/assets/imgs/Rodape_CartaProposta.svg" class="img-rodape">
                      </div>
                    </div>  
                  </div>

                  <div class="template-pagina-comp" v-if="!info.componentes.length > 0"> 
                    <div class="imagem-template-cabecalho espaco-codigo-externo-cabecalho">
                      <div class="titulo-conteudo-detalhes label-codigo-externo"> #{{ this.codigoCarta != null ? this.codigoCarta : this.codigoExterno }} </div>
                      <img src="@/assets/imgs/Cabecalho_PDF_CartaProposta.svg" class="img-cabecalho">
                    </div>

                    <div class="imagem-template-rodape espaco-data-rodape">
                      <div class="data-carta-proposta titulo-conteudo-detalhes data-rodape"> Jaú, {{ this.DiaHoje }} </div>
                      <img src="@/assets/imgs/Rodape_CartaProposta.svg" class="img-rodape">
                    </div>
                  </div>
                </div>

                <div class="container-principal-componentes grupo">
                  <div class="componente-item-container">
                    <div v-for="(data, index) in info.componentes.slice(2)" :key="index">
                      <div class="componente-item" >
                        <div class="imagem-numero-nome-componente">
                          <div class="imagem-grupo-componente">
                            <img src="@/assets/imgs/icone_componente_orcamento.svg" class="img-componente">
                          </div>
                          
                          <div class="numero-nome-componente">
                            <div class="titulo-conteudo-detalhes numero-componente"> Componente {{ index + 3 }}</div>
                            <div class="nome-componente label-conteudo">{{ data.componenteTipoTexto }}</div>
                          </div>
                        </div> 

                        <div class="grupo-componentes">
                          <div class="componentes-medidas">
                            <div class="medidas titulo-conteudo-detalhes"> Medidas </div>
                            <div class="medidas label-conteudo">
                              {{ 
                                (data.numeroComprimento != 0) && (data.numeroLargura != 0)   ? 
                                data.numeroComprimento + ' x ' + data.numeroLargura + ' x ' + data.numeroAltura + 
                                ' x ' + data.numeroAlturaTampa : data.descricaoMedidasTexto
                              }}
                            </div>
                          </div>

                          <div class="componentes-cor-frente">
                            <div class="corFrente titulo-conteudo-detalhes"> Cor Frente </div>
                            <div class="corFrente label-conteudo">{{ data.descricaoCoresFrenteTexto }}</div>
                          </div>

                          <div class="componentes-cor-verso">
                            <div class="corVerso titulo-conteudo-detalhes"> Cor Verso </div>
                            <div class="corVerso label-conteudo">{{ data.descricaoCoresVersoTexto }}</div>
                          </div>

                          <div class="componentes-acabFrente">
                            <div class="acabFrente titulo-conteudo-detalhes"> Acabamento Frente </div>
                            <div class="acabFrente label-conteudo">{{ data.descricaoAcabamentoFrenteTexto }}</div>
                          </div>

                          <div class="componentes-acabVerso">
                            <div class="acabVerso titulo-conteudo-detalhes"> Acabamento Verso </div>
                            <div class="acabVerso label-conteudo">{{ data.descricaoAcabamentoVersoTexto }}</div>
                          </div>

                          <div class="componentes-material">
                            <div class="material titulo-conteudo-detalhes"> Material </div>
                            <div class="material label-conteudo">{{ data.descricaoMaterialTexto }}</div>
                          </div>

                          <div class="componentes-onda">
                            <div class="onda titulo-conteudo-detalhes"> Onda </div>
                            <div class="onda label-conteudo">{{ data.descricaoOndaTexto }}</div>
                          </div>

                          <div class="componentes-capaExt">
                            <div class="capaExt titulo-conteudo-detalhes"> Capa Externa </div>
                            <div class="capaExt label-conteudo">{{ data.descricaoCapaExternaTexto }}</div>
                          </div>

                          <div class="componentes-capaInt">
                            <div class="capaInt titulo-conteudo-detalhes"> Capa Interna </div>
                            <div class="capaInt label-conteudo">{{ data.descricaoCapaInternaTexto }}</div>
                          </div>

                          <div class="componentes-papelOnda">
                            <div class="papelOnda titulo-conteudo-detalhes"> Papel de Onda </div>
                            <div class="papelOnda label-conteudo">{{ data.descricaoPapelOndaTexto }}</div>
                          </div>

                          <div class="componentes-descricao" v-if="data.descricaoSistema == 0">
                            <div class="desc-componente titulo-conteudo-detalhes"> Descrição do Sistema </div>
                            <div class="label-conteudo">{{ data.sistema }}</div>
                          </div>

                          <div class="componentes-produto" v-if="data.descricaoSistema == 2">
                            <div class="produto-comp titulo-conteudo-detalhes"> Produto </div>
                            <div class="label-conteudo">{{ data.produtoSistema }}</div>
                          </div>

                          <div class="componentes-prototipo" v-if="data.descricaoSistema == 3">
                            <div class="prototipo titulo-conteudo-detalhes"> Protótipo </div>
                            <div class="label-conteudo">{{ data.prototipoSistema }}</div>
                          </div>

                          <div class="componentes-embalagem-coletiva" 
                            v-if="data.embalagens != 0 || data.quantidadeOutros != 0"
                          >
                            <div class="embalagem titulo-conteudo-detalhes"> Embalagem Coletiva </div>
                            <div class="labels-embalagem-coletiva">
                              <div class="label-conteudo" v-for="(texto, index) in data.embalagens" :key="index"
                              >{{ texto }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                
                      <!-- <div class="html2pdf__page-break" v-if="index+1/4 === 1"></div> -->
                      <!-- <div class="html2pdf__page-break" v-if="index/4 === 1 && info.componentes.slice(2).slice(index + 1).length > 0 "></div> -->
                      <!-- <div class="html2pdf__page-break" v-if="index+1/4 === 0 && index != this.arrayComponentes.length"></div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="html2pdf__page-break" v-if="deveQuebrar">
            </div>
            
            <!-- <div class="html2pdf__page-break" ></div> -->
            <div 
            v-if="(deveQuebrar && this.orcamentosInformacoes.length === 1) || (this.orcamentosInformacoes.length > 1)"
             class="imagem-template-cabecalho espaco-codigo-externo-cabecalho">
                    <div class=" label-codigo-externo"> #{{ this.codigoCarta != null ? this.codigoCarta : this.codigoExterno }} </div>
                    <img src="@/assets/imgs/Cabecalho_PDF_CartaProposta.svg" class="img-cabecalho">
                  </div>
            
 
            <div class="content-grupo">
             

              <div class="container-ultima-pagina grupo " :class="{'titulo-ultimaPag':!((deveQuebrar && this.orcamentosInformacoes.length === 1) || (this.orcamentosInformacoes.length > 1))}">                           
                <div class="observacao-negociacao">
                  <div class="borda-titulo-grupo">
                    <div class="titulo-grupo"> OBSERVAÇÕES DA NEGOCIAÇÃO </div>
                    <div class="borda-grupo"></div>
                    <div class="mensagem-validade">
                  <div>
                    <!-- {{ cartaPropostaArray.observacaoGeral ? cartaPropostaArray.observacaoGeral : " " }} -->
                    - De acordo com Normas Gráficas (ABIGRAF) todo pedido pode ter variação na quantidade de 10% a mais ou menos.
                    <div class="titulo-grupo"> OBSERVAÇÕES DO ORÇAMENTO </div>
                    <div class="borda-grupo"></div>
                    <div class="mensagem-validade " v-for="(infoComp, index2) in this.orcamentosInformacoes"
                    :key="index2"
                    >
                    {{  
                      infoComp.observacaoProduto == '' || infoComp.observacaoProduto == null || infoComp.observacaoProduto == undefined ? ""  : ' - Solicitação: ' + infoComp.codigoOrcamento + ' - ' + infoComp.observacaoProduto
                    }}
                    </div>

                  </div>
                </div>
                  </div>

                  <div class="conteudo-ultimaPag conteudo-observacoes-negociacao"> 
                    <div class="label-conteudo-ultimaPag"></div>
                  </div>
                </div>
                
                <div class="validade-proposta">
                  <div class="imagem-validade-agenda">
                    <img src="@/assets/imgs/Icone_Agenda.svg" class="img-agenda">
                  </div>

                  <div class="conteudo-validade">
                    <div class="label-validade"> VALIDADE DA PROPOSTA: <div class="data-validade"> 10 DIAS </div></div>                  
                    
                    <div class="mensagem-validade" v-for="(infoComp, index2) in this.orcamentosInformacoes"
                    :key="index2"
                    >
                    
                    <div v-if="index2 === 0">
                      - {{infoComp.observacaoNegociacao ? infoComp.observacaoNegociacao : "Não possui observação." }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="condicoes-pagto">
                  <div class="imagem-moeda">
                    <img src="@/assets/imgs/Icone_Condicoes_Pagto.svg" class="img-moeda">
                  </div>

                  <div class="conteudo-condicoesPagto">
                    <div class="label-condicoesPagto"> CONDIÇÕES DE PAGAMENTO: </div>                  
                    
                    <div class="mensagem-condicoesPagto">
                        <div class="label-conteudo-ultimaPag forma-pagto"> {{ this.formaPagto }} </div>
                    </div>
                  </div>
                </div>

                <div class="tributacoes">
                  <div class="titulo-tributacoes titulo-conteudo-detalhes"> Tributações* </div>

                  <div class="conteudo-tributacoes">
                    <div class="conteudo-icms">
                      <div class="titulo-conteudo-detalhes"> ICMS </div>
                      <div class="label-conteudo">{{ this.valoricms !== 0 ? 'Incluso - '+ this.valoricms + '%' : 'Diferido'}}</div>
                    </div>
                    
                    <div class="conteudo-pis-confins">
                      <div class="titulo-conteudo-detalhes"> PIS / COFINS </div>
                      <div class="label-conteudo">{{ this.valorpiscofins !== 0 ? 'Incluso - '+ this.valorpiscofins + '%' : 'Diferido'}}</div>
                    </div>

                    <div class="conteudo-ipi">
                      <div class="titulo-conteudo-detalhes"> IPI </div>
                      <div class="label-conteudo">
                        <!-- Não incluso - Preço acima + IPI -->
                        {{ this.valoripi == 0 ? 'Não Incluso – Preço acima + IPI' : 'Diferido'}}
                      
                      </div> 
                    </div>
                  </div>
                </div>

                <div class="composicao-carta-proposta">
                  <div class="borda-titulo-grupo">
                    <div class="titulo-grupo"> COMPOSIÇÃO DA CARTA PROPOSTA </div>
                    <div class="borda-grupo"></div>
                  </div>

                  <div class="conteudo-ultimaPag"> 
                    <div class="label-conteudo-ultimaPag"> Possível suspensão ou diferimento dependerá da apresentação da declaração expressa, nos termos da legislação vigente. </div>                                  
                    <div class="label-conteudo-ultimaPag"> De acordo com as Normas Gráficas (ABIGRAF) todo pedido pode ter variação na quantidade de 10% a mais ou menos. </div>
                  </div>

                  <div class="msg-final-doc">
                    <div><div class="label-sem-mais"> Sem mais para o momento, </div> Nos colocamos a vosso dispor.</div>
                    <div class="representante">
                      <div class="titulo-conteudo-cabecalho"> Representante: &nbsp; <div class="label-cabecalho">{{representante}}</div></div>
                    </div>
                </div>
                </div>
              </div>
            </div>
           <br/>
           <br/>
            <!-- <div class="imagem-template-rodape espaco-data-rodape">
                  <img src="@/assets/imgs/Rodape_Orcamento_inicio.svg" class="img-rodape">
            </div> -->
            <div class="html2pdf__page-break"/>

          </div>
        </g-card>
      </div>
    </div>
  </div>

  <div v-if="this.TipoCarta == 1">

    <div class="card-pdf-carta-proposta">
      <div class="conteudo-pdf-carta-proposta">
        <g-card class="card-principal" :temCabecalho="false" :expansivel="false" margem="0" paddingDefault="0">
          <div class="informacoes-pdf-carta-proposta">
            <div 
            class="container-principal-gerador-paginas" 
            >
              <div class="content-grupo">
                <div class="template-pagina">
                  <div class="imagem-template-cabecalho cabecalho-primeiraPag">
                    <img src="@/assets/imgs/Cabecalho_Carta_Proposta.svg" class="img-rodape">

                    <div class="info-carta-cabecalho espaco-data-rodape conteudo-cabecalho-primeiraPag">
                      <div class="numero-carta-proposta titulo-conteudo-detalhes"> Carta-Proposta <div class="codigo-externo-primeiraPag"> #{{ this.codigoCarta != null ? this.codigoCarta : this.codigoExterno }} </div></div>
                      <div class="borda-grupo borda-carta-proposta"></div>
                      <div class="nome-unidade titulo-conteudo-detalhes">{{ cartaPropostaArray.nomeEmpresa }}</div>
                    </div>
                  </div>

                  <div class="imagem-template-rodape">
                    <div class="data-carta-proposta titulo-conteudo-detalhes data-rodape"> Jaú, {{ this.DiaHoje }} </div>
                    <img src="@/assets/imgs/Rodape_CartaProposta.svg" class="img-cabecalho">
                  </div> 
                </div>              

                <div class="grupo" style="margin-top: 6.5rem;">
                  <div class="titulo-referencia-nome-cliente borda-titulo-grupo">
                    <div class="titulo-nome-cliente titulo-grupo"> À <br> {{ cartaPropostaArray.nomeCliente }} </div>
                    <div class="borda-grupo"></div>
                  </div>

                  <div class="informacoes-cliente-sintetico">
                    <div class="cliente descricao-cliente">
                      <div class="titulo-conteudo-detalhes"> A/Sr(a): </div>
                      <div class="nome-cliente label-conteudo">
                        {{
                          inputNomeCliente == "" ? "Nome do Cliente" : inputNomeCliente
                        }}
                      </div>
                    </div>
                    
                    <div class="mensagem label-conteudo"> Conforme solicitado, seguem abaixo preços e condições para fornecimento, a saber </div>
                  </div>
                
                </div>
              </div>       
            </div>
            
            <div class="grupo-info-produto padding-pdf-global">
                    <div class="orcamento-tabela-sintetico">
                      <div class="orcamento-tabela-conteudo">
                        <div class="cabecalho-tabela-sintetico">
                          <div class="titulo-conteudo-detalhes titulo-tabela"> Orçamento </div>
                          <div class="titulo-conteudo-detalhes titulo-tabela"> REF </div>
                          <div class="titulo-conteudo-detalhes titulo-tabela"> Quantidade </div>
                          <div class="titulo-conteudo-detalhes titulo-tabela"> Frete </div>
                          <div class="titulo-conteudo-detalhes titulo-tabela"> Preço </div>
                        </div>
                        <div 
                          class="informacao-tabela" 
                          v-for="(data2, index2) in this.arrayOrcamentosInformacoes"
                          :key="index2"
                        >
                          <div :class="`info-conteudo-sintetico ${index2 % 2 === 0 ? 'pinta-linha' : 'nao-pinta-linha' }`">
                            <div class="label-conteudo label-tabela">{{ data2.codigoNovo}}</div>
                            <div class="label-conteudo label-tabela">{{ data2.nomeProdutoNovo }}</div>
                            <div class="label-conteudo label-tabela">{{ data2.quantidade }}</div>
                            <div class="label-conteudo label-tabela">{{ data2.freteNovo }}</div>
                            <div class="label-conteudo label-tabela"> R$ {{ data2.preco }}</div>

                            
                            
                          </div>
                          
                          <div v-if="index2 % 16 === 0 && index2 > 0" >
                          
                           <div class="html2pdf__page-break"/>

                           

                           <div class="template-pagina">
                  <div class="imagem-template-cabecalho cabecalho-primeiraPag">
                    <!-- <img src="@/assets/imgs/Cabecalho_Carta_Proposta.svg" class="img-rodape"> -->

                    <!-- <div class="info-carta-cabecalho espaco-data-rodape conteudo-cabecalho-primeiraPag">
                      <div class="titulo-conteudo-detalhes label-codigo-externo"> #{{ this.codigoCarta != null ? this.codigoCarta : this.codigoExterno }} </div>
                      <div class="borda-grupo borda-carta-proposta"></div>
                      <div class="nome-unidade titulo-conteudo-detalhes">{{ cartaPropostaArray.nomeEmpresa }}</div>
                    </div> -->

                    <div class="template-pagina content-grupo ">
                  <div class="imagem-template-cabecalho espaco-codigo-externo-cabecalho">
                    <div class="titulo-conteudo-detalhes label-codigo-externo"> #{{ this.codigoCarta != null ? this.codigoCarta : this.codigoExterno }} </div>
                    <img src="@/assets/imgs/Cabecalho_PDF_CartaProposta.svg" class="img-cabecalho">
                  </div>
                </div>
                  </div>



                  <div class="imagem-template-rodape">
                    <div class="data-carta-proposta titulo-conteudo-detalhes data-rodape"> Jaú, {{ this.DiaHoje }} </div>
                    <img src="@/assets/imgs/Rodape_CartaProposta.svg" class="img-cabecalho">
                  </div> 
                </div>  

                <br /> 
                <br /> 
                <br /> 
                <br /> 



                          
                          </div>
                        </div>
                        
                      </div>
                    </div>
            </div>  

            <!-- <div class="html2pdf__page-break"/> -->
            <div class="html2pdf__page-break" v-if="arrayOrcamentosInformacoes.length >= 11"/>

            <div class="template-pagina content-grupo " v-if="arrayOrcamentosInformacoes.length >= 11">
              <div class="imagem-template-cabecalho espaco-codigo-externo-cabecalho">
                <div class="titulo-conteudo-detalhes label-codigo-externo"> #{{ this.codigoCarta != null ? this.codigoCarta : this.codigoExterno }} </div>
                <img src="@/assets/imgs/Cabecalho_PDF_CartaProposta.svg" class="img-cabecalho">
              </div>

              <div class="msg-final-doc">
                <div><div class="label-sem-mais"> Sem mais para o momento, </div> Nos colocamos a vosso dispor.</div>
                
                <div class="representante">
                  <div class="titulo-conteudo-cabecalho"> Representante: &nbsp; <div class="label-cabecalho">{{representante}}</div></div>
                </div>
              </div>
              
              <div class="imagem-template-rodape espaco-data-rodape">
                <img src="@/assets/imgs/Rodape_Orcamento_inicio.svg" class="img-rodape">
              </div>
            </div> <!-- cabeçalho -->

            <div :class="`observacao-negociacao content-grupo padding-pdf-global ${arrayOrcamentosInformacoes.length >= 11 ? 'margin-top' : '' }`">
              <div class="borda-titulo-grupo">
                <div class="titulo-grupo"> OBSERVAÇÕES DA NEGOCIAÇÃO </div>
                <div class="borda-grupo"></div>
                <div class="mensagem-validade">
                  <div>
                    <!-- {{ cartaPropostaArray.observacaoGeral ? cartaPropostaArray.observacaoGeral : " " }} -->
                    - De acordo com Normas Gráficas (ABIGRAF) todo pedido pode ter variação na quantidade de 10% a mais ou menos.
                    <div class="titulo-grupo"> OBSERVAÇÕES DO ORÇAMENTO </div>
                    <div class="borda-grupo"></div>
                    <div class="mensagem-validade" v-for="(infoComp, index2) in this.orcamentosInformacoes"
                    :key="index2"
                    >

                    {{  
                      infoComp.observacaoProduto == '' || infoComp.observacaoProduto == null || infoComp.observacaoProduto == undefined ? ""  : ' - Solicitação: ' + infoComp.codigoOrcamento + ' - ' + infoComp.observacaoProduto
                    }}                    <!-- {{  
                      infoComp.observacaoProduto == '' || infoComp.observacaoProduto == null || infoComp.observacaoProduto == undefined ? ""  : 'Solicitação: ' + infoComp.codigoOrcamento + '-' + infoComp.observacaoProduto
                    }} -->


                    <!-- Solicitação {{ infoComp.codigoOrcamento }}- {{infoComp.observacaoProduto}} -->
                    <!-- <div v-if="index2 === 0">
                     Solicitação {{ infoComp.codigoOrcamento }} - {{infoComp.observacaoProduto ? infoComp.observacaoProduto : "" }}
                      </div> -->
                    </div>

                  </div>
                </div>
              </div>

              <div class="conteudo-ultimaPag conteudo-observacoes-negociacao"> 
                <div class="label-conteudo-ultimaPag"></div>
              </div>
            </div>
              
            <div class="validade-proposta-sintetico content-grupo padding-pdf-global">
              <div class="imagem-validade-agenda">
                <img src="@/assets/imgs/Icone_Agenda.svg" class="img-agenda">
              </div>

              <div class="conteudo-validade">
                <div class="label-validade"> VALIDADE DA PROPOSTA: <div class="data-validade"> 10 DIAS </div></div>                  
                
                <div class="mensagem-validade" v-for="(infoComp, index2) in this.orcamentosInformacoes"
                :key="index2"
                >
                  <div v-if="index2 === 0">
                    - {{infoComp.observacaoNegociacao ? infoComp.observacaoNegociacao : "Não possui observação." }}
                  </div>
                </div>
              </div>
              
            </div>

            <div class="condicoes-pagto-sintetico content-grupo padding-pdf-global">
              <div class="imagem-moeda">
                <img src="@/assets/imgs/Icone_Condicoes_Pagto.svg" class="img-moeda">
              </div>

              <div class="conteudo-condicoesPagto">
                <div class="label-condicoesPagto"> CONDIÇÕES DE PAGAMENTO: </div>                  
                
                <div class="mensagem-condicoesPagto">
                    <div class="label-conteudo-ultimaPag forma-pagto"> {{ this.formaPagto }} </div>
                </div>
              </div>
            </div>
                
            <div class="html2pdf__page-break" v-if="arrayOrcamentosInformacoes.length >= 7 && arrayOrcamentosInformacoes.length < 11"/>

            <div class="template-pagina content-grupo " v-if="arrayOrcamentosInformacoes.length >= 7 && arrayOrcamentosInformacoes.length < 11">
              <div class="imagem-template-cabecalho espaco-codigo-externo-cabecalho">
                <div class="titulo-conteudo-detalhes label-codigo-externo"> #{{ this.codigoCarta != null ? this.codigoCarta : this.codigoExterno }} </div>
                <img src="@/assets/imgs/Cabecalho_PDF_CartaProposta.svg" class="img-cabecalho">
              </div>

              <div class="msg-final-doc">
                <div><div class="label-sem-mais"> Sem mais para o momento, </div> Nos colocamos a vosso dispor.</div>
                
                <div class="representante">
                  <div class="titulo-conteudo-cabecalho"> Representante: &nbsp; <div class="label-cabecalho">{{representante}}</div></div>
                </div>
              </div>
              
              <div class="imagem-template-rodape espaco-data-rodape">
                <img src="@/assets/imgs/Rodape_Orcamento_inicio.svg" class="img-rodape">
              </div>
            </div> <!-- cabeçalho -->

            <div :class="`tributacoes-sinteitco content-grupo padding-pdf-global ${arrayOrcamentosInformacoes.length >= 7 && arrayOrcamentosInformacoes.length < 11 ? 'margin-top' : ''}`">
              <div class="titulo-tributacoes titulo-conteudo-detalhes"> Tributações* </div>

              <div class="conteudo-tributacoes">
                <div class="conteudo-icms">
                  <div class="titulo-conteudo-detalhes"> ICMS </div>
                  <div class="label-conteudo">{{ this.valoricms !== 0 ? 'Incluso - '+ this.valoricms + '%' : 'Diferido'}}</div>
                </div>
                
                <div class="conteudo-pis-confins">
                  <div class="titulo-conteudo-detalhes"> PIS / COFINS </div>
                  <div class="label-conteudo">{{ this.valorpiscofins !== 0 ? 'Incluso - '+ this.valorpiscofins + '%' : 'Diferido'}}</div>
                </div>

                <div class="conteudo-ipi">
                  <div class="titulo-conteudo-detalhes"> IPI </div>
                  <div class="label-conteudo">
                    {{ this.valoripi == 0 ? 'Não Incluso – Preço acima + IPI' : 'Diferido'}}
                                        <!-- {{ this.valoripi !== 0 ? 'Incluso - '+ this.valoripi + '%' : 'Diferido'}}  -->
                  
                  </div> 
                </div>

                <!-- <div class="conteudo-frete">
                  <div class="titulo-conteudo-detalhes"> Frete </div>
                  <div class="label-conteudo">{{ this.tipoFrete }}</div>
                </div> -->
              </div>
            </div>

            <div class="html2pdf__page-break" v-if="arrayOrcamentosInformacoes.length > 0 && arrayOrcamentosInformacoes.length < 7"/>

            <div class="template-pagina content-grupo " v-if="arrayOrcamentosInformacoes.length > 0 && arrayOrcamentosInformacoes.length < 7">
              <div class="imagem-template-cabecalho espaco-codigo-externo-cabecalho">
                <div class="titulo-conteudo-detalhes label-codigo-externo"> #{{ this.codigoCarta != null ? this.codigoCarta : this.codigoExterno }} </div>
                <img src="@/assets/imgs/Cabecalho_PDF_CartaProposta.svg" class="img-cabecalho">
              </div>
              

              
              <div class="imagem-template-rodape espaco-data-rodape">
                <img src="@/assets/imgs/Rodape_Orcamento_inicio.svg" class="img-rodape">
              </div>
            </div><!-- cabeçalho -->

            <div :class="`composicao-carta-proposta padding-pdf-global content-grupo ${arrayOrcamentosInformacoes.length > 0 && arrayOrcamentosInformacoes.length < 7 ? 'margin-top' : '' }`">
              <div class="borda-titulo-grupo">
                <div class="titulo-grupo"> COMPOSIÇÃO DA CARTA PROPOSTA </div>
                <div class="borda-grupo"></div>
              </div>

              <div class="conteudo-ultimaPag"> 
                <div class="label-conteudo-ultimaPag"> Possível suspensão ou diferimento dependerá da apresentação da declaração expressa, nos termos da legislação vigente. </div>                                  
                <div class="label-conteudo-ultimaPag"> De acordo com as Normas Gráficas (ABIGRAF) todo pedido pode ter variação na quantidade de 10% a mais ou menos. </div>
              </div>
              <div class="msg-final-doc">
                <div><div class="label-sem-mais"> Sem mais para o momento, </div> Nos colocamos a vosso dispor.</div>
                
                <div class="representante">
                  <div class="titulo-conteudo-cabecalho"> Representante: &nbsp; <div class="label-cabecalho">{{representante}}</div></div>
                </div>
              </div>

            </div>

            <div class="html2pdf__page-break"></div>

          </div>
          
        </g-card>
      </div>
    </div>

  </div>

  
                
  <div class="imagem-template-rodape espaco-data-rodape">
    <img src="@/assets/imgs/Rodape_Orcamento_inicio.svg" class="img-rodape-2">
  </div>
           
 <!-- </g-pdf> -->

  </div>  
</template>

<script>
import PDFCartaPropostaFinalizado from './PDFCartaPropostaFinalizado.js'
export default PDFCartaPropostaFinalizado
</script>

<style scoped>


.img-rodape-2{
  width: 100%;
  z-index: 3000;
  position: absolute;
  bottom: 0;
}
.componente-item-container{
  display:flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: space-between;
  padding: 4rem 0;
  height: 100%;
  width: 100%;
  row-gap: 8rem;

}


.componente-item{
  
  background-color: #F9F9F9;
  display: flex;
  width: 22.2rem; 
  flex-direction: column;
  align-items: space-between;
  row-gap: 0.5rem;
  padding: 1rem 1rem 0.5rem;
  border-radius: 0.5rem;

}
.padding-pdf-global {
  padding: 30px;
}
.card-pdf-carta-proposta {
  font-family: 'MontSerrat';
}

.content-grupo {
  position: relative;
  height: 100%;
  width: 100%;
}
.margin-top {
  margin-top: 80px;
}
.template-pagina {
  position: absolute;
  height: 70.125rem;
  width: 100%;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
}
.imagem-template-cabecalho {
  display: flex;
  align-items: flex-start;
}
.imagem-template-rodape {
  position: relative;
  display: flex;
  align-items: flex-end;
}

.img-cabecalho, .img-rodape {
  width: 100%;
}

.numero-carta-proposta {
  display: flex;
  column-gap: 0.3rem;
}

.espaco-codigo-externo-cabecalho {
  position: relative;
  
}

.label-codigo-externo {
  position: absolute;
  height: 100%;
  width: 99.25%;
  color: #4f2c19 !important;
  font-size: 0.9rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.08rem;
  display: flex;
  align-items: center;
  top: 0;
  left: 0;
  padding: 0 0 0.2rem 11.5rem;
  z-index: 1000;
}

.codigo-externo-primeiraPag {
  font-weight: 600 !important;
  letter-spacing: 0.08rem;
}

.espaco-data-rodape {
  position: relative;
}
.data-rodape {
  color: #fff !important;
  font-size: 0.75rem !important;
  font-weight: 500;
  position: absolute;
  height: 100%;
  width: 99.25%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  left: 0;
  padding: 0.35rem 1.5rem 0.3rem 0;
  z-index: 1000;
}

.msg-final-doc {
  width: 100%;
  color: #707070;
  font-size: 1rem;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  row-gap: 1rem;

}
.label-sem-mais {
  color: #3f3f3f;
  font-weight: 600;
}

.cabecalho-primeiraPag {
  position: relative;
}
.cabecalho-primeiraPag .img-rodape {
  position: absolute;
  z-index: 1;
}
.info-carta-cabecalho {
  position: absolute;
  width: 99.25%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  row-gap: 0.1rem;
  padding: 1rem 1.5rem 0 0;
  top: 0;
  left: 0;
  z-index: 1000;
}

.info-carta-cabecalho .titulo-conteudo-detalhes {
  font-size: 0.85rem;
}

.numero-carta-proposta {
  padding-bottom: 0.3rem;
}

.nome-unidade {
  font-size: 1.1rem !important;
  margin: 0 !important;
  padding: 0 !important;
}

.numero-carta-proposta {
  font-weight: 500;
}

.grupo {
  width: 99%;
}

.grupo-primeiraPag, .grupo {
  position: absolute;
  padding: 2rem 2rem 0;
}
.orcamento-tabela-sintetico {
  /* margin-top: 250px; */
  margin-top: 15rem;
}

.grupo-info-produto {
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 2rem;
}

.conteudo-orcamento-info-produto {
  height: 8rem;
  width: 100%;
  display: grid;
  grid-template-columns: 2fr 1fr;
  column-gap: 1rem;
} 

.orcamento-produto {
  height: 100%;
  background-color: #F9F9F9;
  display: grid;
  grid-template-columns: 0.6fr 4fr;
  padding: 1.5rem 1rem;
  column-gap: 1rem;
  border-radius: 0.5rem;
  align-items: center;
}

.container-imagem-produto {
  height: 100%;
  background-color: #F9F9F9;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.3rem;
  border-radius: 0.8rem;
}

.conteudo-sem-imagem {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 1rem;
}

.imagem-produto {
  display: flex;
  justify-content: center;
  align-items: center;
}

.img-produto {
  height: 5rem;
}

.img-produto-oficial{
  height: 9rem;
}

.label-sem-imagem {
  font-size: 0.8rem !important;
  color: #A5948B !important;
  margin-bottom: 0 !important;
}

.imagem-caixa-orcamento {
  display: flex;
  align-items: center;
  justify-content: center;
}
.img-orcamento {
  height: 3.5rem;
}
.conteudo-orcamento {
  display: flex;
  flex-direction: column;
  row-gap: 0.3rem;
}

.titulo-conteudo-orcamento {
  display: flex;
  column-gap: 0.6rem;
}

.produto-nome {
  min-width: max-content;
}

.titulo-conteudo-orcamento .titulo-conteudo-detalhes {
  font-size: 0.8rem !important;
}
.pinta-label {
  color: #4f2c19 !important;
}

.orcamento-tabela {
  width: 45.5rem;
  background-color: #F9F9F9;
  padding: 0.8rem 1rem;
  border-radius: 0.5rem;
}

.cabecalho-tabela-sintetico, .info-conteudo-sintetico {
  display: grid;
  grid-template-columns: repeat(5, minmax(4rem, 1fr));
  grid-auto-rows: auto;
  align-items: center;
  justify-items: center;
}
.cabecalho-tabela, .info-conteudo {
  display: grid;
  grid-template-columns: repeat(2, minmax(4rem, 1fr));
  grid-auto-rows: auto;
  align-items: center;
  justify-items: center;
}

.titulo-tabela {
  padding-bottom: 1rem;
}

.info-conteudo {
  padding: 0.3rem 0;
}

.info-conteudo .label-conteudo {
  color: #4D4D4D;
  margin-bottom: 0;
}

.pinta-linha {
  background-color: #E3E3E3;
}

.nao-pinta-linha {
  background-color: transparent;
}

.tributacoes-sinteitco {
  background-color: #F9F9F9;
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  margin-left: 2rem;
  width: 91%;
  border-radius: 0.5rem;
}
.tributacoes {
  background-color: #F9F9F9;
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  padding: 0.8rem 1rem 0.5rem;
  border-radius: 0.5rem;
}
.conteudo-tributacoes {
  display: flex;
  column-gap: 2.5rem;
}

.borda-titulo-grupo {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 0.8rem;
}

.titulo-grupo {
  width: 100%;
  color: #4f2c19;
  text-align: left;
  font-size: 1.1rem;
  font-family: "MontSerrat";
  font-weight: 700;
  padding-bottom: 0.3rem;
  letter-spacing: 1px;
}

.espacamento-novo-orcamento {
  margin-top: 6rem;
}

.titulo-grupo-espacamento, .espacamento-novo-orcamento {
  margin-top: 5rem;
  row-gap: 3.5rem;
}

.borda-grupo {
  width: 5rem;
  height: 3px;
  background-color: #FCB315;
}

.borda-carta-proposta {
  background-color: #4f2c19 !important;
  border-radius: 0.5rem;
}

.conteudo-cabecalho-primeiraPag {
  display: flex;
  flex-direction: column;
  row-gap: 0.8rem;
}

.titulo-conteudo-detalhes {
  color: #3f3f3f;
  font-size: 0.8rem;
  margin-top: 0.1rem;
}
.label-conteudo {
  font-size: 0.8rem;
}

.container-info-introducao-carta-proposta {
  margin-top: 6.5rem;
}

.titulo-referencia-nome-cliente {
  margin-bottom: 1.2rem;
}
	
.informacoes-cliente {
  display: flex;
  flex-direction: column;
  row-gap: 0.2rem;
  margin-bottom: 1.2rem;
}
.informacoes-cliente-sintetico {
  display: flex;
  flex-direction: column;
  /* margin-top: 50px; */
  row-gap: 0.2rem;
  margin-bottom: 1.2rem;
}

.descricao-cliente {
  display: flex;
  align-items: center;
  column-gap: 0.4rem;
}

.descricao-cliente .titulo-conteudo-detalhes {
  margin-top: 0;
}

.descricao-cliente .label-conteudo {
  margin-bottom: 0;
}

.container-base {
  position: absolute;
  width: 100%;
}

.contador-pag-componentes {
  position: relative;
  z-index: 2000;
  left: 0;
}

.template-pagina-comp {
  height: 70.125rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.container-principal-componentes {
  position: relative;
  z-index: 1;
}

.titulo-componentes {
  margin-top: 2rem;
}

.container-componentes {
  height: auto;
  width: 99.25%;
  display: flex;
  flex-wrap: wrap;
  /* column-gap: 1.2rem; */
  row-gap: 2rem;
  margin-top: 1rem;
}

.container-componentes-t2 {
  margin-top: 4rem;
}

.box-componente-t1 {
  min-height: 25rem;
  width: 22.2rem; 
  background-color: #F9F9F9;
  display: flex;
  flex-direction: column;
  align-items: space-between;
  row-gap: 0.5rem;
  padding: 1rem 1rem 0.5rem;
  border-radius: 0.5rem;
}

.box-componente-t2 {
  min-height: 25rem;
  width: 22.2rem; 
  background-color: #F9F9F9;
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
  padding: 1rem 1rem 0.5rem;
  border-radius: 0.5rem;
}
.box-componente-espacamento-t1 {
  margin-right: 0.75rem;
}
.box-componente-espacamento-t2 {
  margin-right: 1.2rem;
}

.box-componente-espacamento-topo {
  margin-top: 6rem
}

.imagem-numero-nome-componente {
  display: flex;
  column-gap: 1rem;
}
.img-componente {
  height: 2.5rem;
  width: auto;
}

.numero-nome-componente {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 0.4rem;
  
}

.numero-nome-componente .titulo-conteudo-detalhes {
  margin-top: 0;
}
.numero-componente {
  color: #4f2c19;
}

.grupo-componentes {
  display: grid;
  grid-template-columns: repeat(2, minmax(4rem, 1fr));
  grid-auto-rows: auto;
  gap: 0.5rem 0.2rem;
  
}
.grupo-componentes .componentes-medidas { grid-area: 1 / 1 / 2 / 2; }
.grupo-componentes .componentes-cor-frente { grid-area: 2 / 1 / 3 / 2; }
.grupo-componentes .componentes-cor-verso { grid-area: 2 / 2 / 3 / 3; }
.grupo-componentes .componentes-acabFrente { grid-area: 3 / 1 / 4 / 2; }
.grupo-componentes .componentes-acabVerso { grid-area: 3 / 2 / 4 / 3; }
.grupo-componentes .componentes-material { grid-area: 4 / 1 / 5 / 2; }
.grupo-componentes .componentes-onda { grid-area: 4 / 2 / 5 / 3; }
.grupo-componentes .componentes-capaExt { grid-area: 5 / 1 / 6 / 2; }
.grupo-componentes .componentes-capaInt { grid-area: 5 / 2 / 6 / 3; }
.grupo-componentes .componentes-papelOnda { grid-area: 6 / 1 / 7 / 2; }
.grupo-componentes .componentes-embalagem-coletiva { grid-column: 1 / 3; }

.labels-embalagem-coletiva {
  display: flex;
  flex-wrap: wrap;
  column-gap: 1.5rem;
  width: 100%;
}

.titulo-ultimaPag {
  margin-top: 4rem;
}

.page-break {
  page-break-after: always;
}

.container-ultima-pagina {
  width: 99.25%;
  font-family: 'MontSerrat';
  text-align: justify;
  display: flex;
  flex-direction: column;
  /* espaçamento dos itens da última página do pdf */
  row-gap: .5rem;
}

.conteudo-ultimaPag {
  display: flex;
  flex-direction: column;
  row-gap: 1.5rem;
}

.label-conteudo-ultimaPag, .mensagem-validade {
  color: #4D4D4D;
    /* tamamho da fonte da observação */
  font-size: .8rem;
  font-family: 'MontSerrat';
}
.validade-proposta, .condicoes-pagto {
  background-color: #F9F9F9;
  border-radius: 0.5rem;
  display: grid;
  grid-template-columns: 0.6fr 4fr;
  column-gap: 1rem;
  padding: 1rem;
  align-items: center;
}

.validade-proposta-sintetico, .condicoes-pagto-sintetico {
  background-color: #F9F9F9;;
  border-radius: 0.5rem;
  display: grid;
  grid-template-columns: 0.6fr 4fr;
  column-gap: 1rem;
  margin-left: 2rem;
  width: 91%;
  align-items: center;
  justify-content: center;
}
.imagem-validade-agenda, .imagem-moeda {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 0.2rem;
}
.img-agenda {
  height: 4rem;
}

.img-moeda {
  height: 3.5rem;
}

.conteudo-validade, .conteudo-condicoesPagto {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.label-validade, .label-condicoesPagto {
  color: #4f2c19;
  font-size: 0.9rem;
  font-weight: 700;
  display: flex;
  column-gap: 0.5rem;
  margin-bottom: 0.8rem;
}
.data-validade {
  color: #4D4D4D;
  font-weight: 500;
}
.mensagem-validade, .conteudo-condicoes-pagto {
  display: flex;
  flex-direction: column;
}

.conteudo-condicoes-pagto {
  row-gap: 0.5rem;
}

.quebra-linha {
  display: flex;
  flex-wrap: wrap;
}

.nome-unidade {
  font-size: 0.95rem !important;
}
</style>


